import React, { FC, useState, useEffect } from "react";
import { Font } from "@react-pdf/renderer";
import { initialInvoice, initialProductLine } from "./data/initData";
import Document from "./Document";
import Page from "./Page";
import "./invoice.css";
import View from "./View";
import EditableInput from "./EditableInput";
import EditableSelect from "./EditableSelect";
import EditableCalendarInput from "./EditableCalenderInpu";
import format from "date-fns/format";
import Text from "./Text";
import EditableTextarea from "./EditableTextarea";
import DownloadPDF from "./DownloadPDF";
import { Endpoint } from "../../api/base";
import {
  getClient,
  getUser,
  getUserProfileTokenName,
} from "../shared/helpers/helper";
import EditableFileImage from "./EditableFileImage";
import { IconButton, makeStyles } from "@material-ui/core";

Font.register({
  family: "Nunito",
  fonts: [
    { src: "https://fonts.gstatic.com/s/nunito/v12/XRXV3I6Li01BKofINeaE.ttf" },
    {
      src: "https://fonts.gstatic.com/s/nunito/v12/XRXW3I6Li01BKofA6sKUYevN.ttf",
      fontWeight: 600,
    },
  ],
});

function InvoicePage({
  data,
  pdfMode,
  caseData,
  invoices,
  check,
  invoiceIndex,
}) {
  const [invoice, setInvoice] = useState(
    data ? { ...data } : { ...initialInvoice },
  );
  // const [client, setClient] = useState(null);
  const [serviceTotal, setServiceTotal] = useState();
  const [expenseTotal, setExpenseTotal] = useState();
  const [subTotal, setSubTotal] = useState();
  const [saleTax, setSaleTax] = useState();
  const invoiceDate =
    invoices?.invoice_details.invoice_date !== ""
      ? new Date(invoices?.invoice_details.invoice_date)
      : new Date();

  const invoiceDueDate =
    invoice.invoiceDueDate !== ""
      ? new Date(invoice.invoiceDueDate)
      : new Date(invoiceDate.valueOf());

  if (invoice.invoiceDueDate === "") {
    invoiceDueDate.setDate(invoiceDueDate.getDate() + 30);
  }

  useEffect(() => {
    // 2022dev20000
    // caseData.case_detail.file_no

    if (!check) {
      Endpoint.getClients()
        .then((res) => {
          if (res.data.length !== 0) {
            let clientDetail = getClient(
              res.data,
              caseData.case_detail.client_id,
            );
            const userInfo = getUser();
            const newInvoice = { ...invoice };

            // setClient(clientDetail);
            newInvoice["name"] = userInfo?.user_name;
            // newInvoice["companyAddress"] = userInfo?.address;
            // newInvoice["companyAddress2"] = "";
            newInvoice["clientName"] = clientDetail.client_name;
            newInvoice["clientAddress"] = clientDetail.street_address;
            newInvoice["clientAddress2"] =
              `${clientDetail.city} ${clientDetail.state} ${clientDetail.zip_code}`;

            newInvoice["invoiceId"] = invoices?.invoice_id;
            newInvoice["fileNoTitle"] = invoices?.file_no;
            newInvoice["fileTypeTitle"] = invoices?.file_type;
            newInvoice["invoiceDate"] = invoices?.invoice_details.invoice_date;

            newInvoice["invoiceDueDate"] = invoiceDueDate
              .toISOString()
              .split("T")[0];
            newInvoice["referenceNoTitle"] = invoices?.client_file_no;
            newInvoice["subjectTitle"] = invoices?.subject;
            newInvoice["notes"] = invoices?.accounting_notes;

            var rate = clientDetail.hourly_rate;

            newInvoice["retainerCredit"] =
              invoices?.invoice_details?.retainer_credit;
            const serviceLine = [];
            const expenseLine = [];
            serviceLine.push({
              description: "Staff Investigator",
              quantity:
                invoices?.invoice_breakdown?.staff_investigator_hours?.quantity,
              rate: invoices?.invoice_breakdown?.staff_investigator_hours?.rate,
              amount:
                invoices?.invoice_breakdown?.staff_investigator_hours?.amount,
            });
            serviceLine.push({
              description: "Field Investigator",
              quantity:
                invoices?.invoice_breakdown?.field_investigator_hours?.quantity,
              rate: invoices?.invoice_breakdown?.field_investigator_hours?.rate,
              amount:
                invoices?.invoice_breakdown?.field_investigator_hours?.amount,
            });

            expenseLine.push({
              description: "Database Search",
              quantity:
                invoices?.invoice_breakdown?.database_searches_hours?.quantity,
              rate: invoices?.invoice_breakdown?.database_searches_hours?.rate,
              amount:
                invoices?.invoice_breakdown?.database_searches_hours?.amount,
            });
            expenseLine.push({
              description: "Field Investigator Database Searches",
              quantity:
                invoices?.invoice_breakdown
                  ?.field_investigator_database_searches_hours?.quantity,
              rate: invoices?.invoice_breakdown
                ?.field_investigator_database_searches_hours?.rate,
              amount:
                invoices?.invoice_breakdown
                  ?.field_investigator_database_searches_hours?.amount,
            });
            expenseLine.push({
              description: "Field Investigator Mileage",
              quantity:
                invoices?.invoice_breakdown?.field_investigator_mileage_hours
                  ?.quantity,
              rate: invoices?.invoice_breakdown
                ?.field_investigator_mileage_hours?.rate,
              amount:
                invoices?.invoice_breakdown?.field_investigator_mileage_hours
                  ?.amount,
            });

            newInvoice["total"] = invoices?.invoice_details.amount_outstanding;

            setInvoice({ ...newInvoice, serviceLine, expenseLine });
          }
        })
        .catch((err) => {});
    }
  }, []);

  const dateFormat = "MMM dd, yyyy";
  const handleChange = (name, value) => {
    if (name !== "productLines") {
      const newInvoice = { ...invoice };
      newInvoice[name] = value;
      // if (name === 'logoWidth' && typeof value === 'number') {
      //   newInvoice[name] = value
      // } else if (name !== 'logoWidth' && typeof value === 'string') {
      //   newInvoice[name] = value
      // }

      setInvoice(newInvoice);
    }
  };

  const calculateAmount = (quantity, rate) => {
    const quantityNumber = parseFloat(quantity);
    const rateNumber = parseFloat(rate);
    const amount =
      quantityNumber && rateNumber ? quantityNumber * rateNumber : 0;

    return amount.toFixed(2);
  };

  useEffect(() => {
    let subTotal = 0;

    invoice.serviceLine.forEach((productLine) => {
      const quantityNumber = parseFloat(productLine.quantity);
      const rateNumber = parseFloat(productLine.rate);
      const amount =
        quantityNumber && rateNumber ? quantityNumber * rateNumber : 0;

      subTotal += amount;
    });

    setServiceTotal(subTotal);

    let subTotal2 = 0;

    invoice.expenseLine.forEach((productLine) => {
      const quantityNumber = parseFloat(productLine.quantity);
      const rateNumber = parseFloat(productLine.rate);
      const amount =
        quantityNumber && rateNumber ? quantityNumber * rateNumber : 0;

      subTotal2 += amount;
    });

    setExpenseTotal(subTotal2);

    setSubTotal(subTotal + subTotal2 - invoice?.retainerCredit);
  }, [invoice.serviceLine, invoice.expenseLine]);
  return (
    <Document pdfMode={pdfMode}>
      <Page className="invoice-wrapper" pdfMode={pdfMode}>
        {!pdfMode && (
          <>
            <DownloadPDF
              data={invoice}
              caseData={caseData}
              check={true}
              invoices={invoices}
              invoiceIndex={invoiceIndex}
            />
          </>
        )}
        <View className="invoice-flex" pdfMode={pdfMode}>
          <View className="invoice-w-50 invoice-p-10" pdfMode={pdfMode}>
            <EditableFileImage
              className="invoice-flex invoice-logo invoice-pb-30"
              placeholder="Your Logo"
              value={invoice.logo}
              width={invoice.logoWidth}
              pdfMode={pdfMode}
              onChangeImage={(value) => handleChange("logo", value)}
              onChangeWidth={(value) => handleChange("logoWidth", value)}
            />
          </View>
          <View className="invoice-w-50 invoice-p-10" pdfMode={pdfMode}>
            <Text
              className="invoice-fs-30 invoice-right invoice-bold"
              placeholder="Invoice"
              pdfMode={pdfMode}
            >
              {invoice.title}
            </Text>
          </View>
        </View>
        <View className="invoice-flex" pdfMode={pdfMode}>
          <View className="invoice-flex invoice-p-10" pdfMode={pdfMode}>
            <View className="invoice-w-45" pdfMode={pdfMode}>
              <EditableInput
                className="invoice-bold invoice-dark  "
                value={invoice.billTo}
                onChange={(value) => handleChange("billTo", value)}
                pdfMode={pdfMode}
              />
              <EditableInput
                className="invoice-fs-12"
                placeholder="Your Client's Name"
                value={invoice?.clientName}
                // value={client?.client_name ? client?.client_name : "-"}
                onChange={(value) => handleChange("clientName", value)}
                pdfMode={pdfMode}
              />
              <EditableInput
                className="invoice-fs-12"
                placeholder="Client's Address"
                value={invoice?.clientAddress}
                // value={client?.street_address ? client?.street_address : "-"}
                onChange={(value) => handleChange("clientAddress", value)}
                pdfMode={pdfMode}
              />
              <EditableInput
                className="invoice-fs-12"
                placeholder="City, State Zip"
                value={invoice?.clientAddress2}
                // value={`${client?.city ? client?.city : "-"}, ${
                //   client?.state ? client?.state : "-"
                // }, ${client?.zip_code ? client?.zip_code : "-"}`}
                onChange={(value) => handleChange("clientAddress2", value)}
                pdfMode={pdfMode}
              />
            </View>
            <View className="invoice-w-55" pdfMode={pdfMode}>
              <View className="invoice-flex " pdfMode={pdfMode}>
                <View className="invoice-w-40 " pdfMode={pdfMode}>
                  <EditableInput
                    className="bold"
                    value={invoice.invoiceDateLabel}
                    onChange={(value) =>
                      handleChange("invoiceDateLabel", value)
                    }
                    pdfMode={pdfMode}
                  />
                </View>
                <View className="invoice-w-60 " pdfMode={pdfMode}>
                  <EditableInput
                    className="bold invoice-fs-12"
                    value={format(invoiceDate, dateFormat)}
                    onChange={(value) =>
                      handleChange("invoiceDateLabel", value)
                    }
                    pdfMode={pdfMode}
                  />
                </View>
              </View>
              <View className="invoice-flex " pdfMode={pdfMode}>
                <View className="invoice-w-40 invoice-mt-5 " pdfMode={pdfMode}>
                  <EditableInput
                    className="bold"
                    value={invoice.invoiceTitleLabel}
                    onChange={(value) =>
                      handleChange("invoiceTitleLabel", value)
                    }
                    pdfMode={pdfMode}
                  />
                </View>
                <View className="invoice-w-55 invoice-mt-5 " pdfMode={pdfMode}>
                  <EditableInput
                    className="invoice-fs-12"
                    placeholder="INV-12"
                    value={invoice?.invoiceId}
                    onChange={(value) => handleChange("invoiceTitle", value)}
                    pdfMode={pdfMode}
                  />
                </View>
              </View>
              <View className="invoice-flex " pdfMode={pdfMode}>
                <View className="invoice-w-40 invoice-mt-5 " pdfMode={pdfMode}>
                  <EditableInput
                    className="bold"
                    value={invoice.fileNoTitleLabel}
                    onChange={(value) =>
                      handleChange("fileNoTitleLabel", value)
                    }
                    pdfMode={pdfMode}
                  />
                </View>
                <View className="invoice-w-55 invoice-mt-5 " pdfMode={pdfMode}>
                  <EditableInput
                    className="invoice-fs-12"
                    placeholder="-"
                    value={invoices?.file_no}
                    onChange={(value) => handleChange("fileNoTitle", value)}
                    pdfMode={pdfMode}
                  />
                </View>
              </View>
              <View className="invoice-flex " pdfMode={pdfMode}>
                <View className="invoice-w-40 invoice-mt-5 " pdfMode={pdfMode}>
                  <EditableInput
                    className="bold"
                    value={invoice.fileTypeTitleLabel}
                    onChange={(value) =>
                      handleChange("fileNoTitleLabel", value)
                    }
                    pdfMode={pdfMode}
                  />
                </View>
                <View className="invoice-w-55 invoice-mt-5 " pdfMode={pdfMode}>
                  <EditableInput
                    className="invoice-fs-12"
                    placeholder="-"
                    value={invoices?.file_type}
                    onChange={(value) => handleChange("fileNoTitle", value)}
                    pdfMode={pdfMode}
                  />
                </View>
              </View>
              <View className="invoice-flex " pdfMode={pdfMode}>
                <View className="invoice-w-40 " pdfMode={pdfMode}>
                  <EditableInput
                    className="bold"
                    value={invoice.invoiceDueDateLabel}
                    onChange={(value) =>
                      handleChange("invoiceDueDateLabel", value)
                    }
                    pdfMode={pdfMode}
                  />
                </View>
                <View className="invoice-w-60 " pdfMode={pdfMode}>
                  <EditableInput
                    className="bold invoice-fs-12"
                    value={format(invoiceDueDate, dateFormat)}
                    onChange={(value) =>
                      handleChange("invoiceDateLabel", value)
                    }
                    pdfMode={pdfMode}
                  />
                </View>
              </View>
            </View>
          </View>
        </View>
        <View className="invoice-flex" pdfMode={pdfMode}>
          <View className="invoice-w-45" pdfMode={pdfMode}>
            <EditableInput
              className="invoice-bold invoice-dark "
              placeholder="Remit Payment to:"
              value={invoice.remitPaymentTo}
              onChange={(value) => handleChange("companyName", value)}
              pdfMode={pdfMode}
            />
            <EditableInput
              className="fc-b"
              placeholder="Your Company"
              value={invoice.companyName}
              onChange={(value) => handleChange("companyName", value)}
              pdfMode={pdfMode}
            />
            <EditableInput
              className="fc-b"
              placeholder="Company's Address"
              value={invoice.companyAddress}
              onChange={(value) => handleChange("name", value)}
              pdfMode={pdfMode}
            />
            <EditableInput
              className="fc-b"
              placeholder="Company's Address2"
              value={invoice.companyAddress2}
              onChange={(value) => handleChange("companyAddress", value)}
              pdfMode={pdfMode}
            />
            {/* <EditableInput
              placeholder="City, State Zip"
              value={invoice.companyAddress2}
              onChange={(value) => handleChange('companyAddress2', value)}
              pdfMode={pdfMode}
            /> */}
            {/* <EditableSelect
              options={countryList}
              value={invoice.companyCountry}
              onChange={(value) => handleChange('companyCountry', value)}
              pdfMode={pdfMode}
            /> */}
          </View>

          <View className="invoice-w-55" pdfMode={pdfMode}>
            <View className="invoice-flex " pdfMode={pdfMode}>
              <View className="invoice-w-40 invoice-mt-5 " pdfMode={pdfMode}>
                <EditableInput
                  className="bold"
                  value={invoice.referenceNoTitleLabel}
                  onChange={(value) => handleChange("invoiceTitleLabel", value)}
                  pdfMode={pdfMode}
                />
              </View>
              <View className="invoice-w-60 invoice-mt-5 " pdfMode={pdfMode}>
                <EditableInput
                  placeholder="-"
                  value={invoices?.client_file_no}
                  onChange={(value) => handleChange("invoiceTitle", value)}
                  pdfMode={pdfMode}
                />
              </View>
            </View>
            <View className="invoice-flex " pdfMode={pdfMode}>
              <View className="invoice-w-40 invoice-mt-5 " pdfMode={pdfMode}>
                <EditableInput
                  className="bold"
                  value={invoice.subjectTitleLabel}
                  onChange={(value) => handleChange("invoiceTitleLabel", value)}
                  pdfMode={pdfMode}
                />
              </View>
              <View className="invoice-w-60 invoice-mt-5 " pdfMode={pdfMode}>
                <EditableInput
                  placeholder="-"
                  value={invoices?.subject}
                  onChange={(value) => handleChange("invoiceTitle", value)}
                  pdfMode={pdfMode}
                />
              </View>
            </View>
          </View>
        </View>

        {/* SERVICELINE */}
        <View
          className="invoice-mt-20 invoice-bg-dark invoice-flex"
          pdfMode={pdfMode}
        >
          <View className="invoice-w-48 invoice-p-4-8" pdfMode={pdfMode}>
            <EditableInput
              className="invoice-white invoice-bold"
              value={invoice.serviceLineDescription}
              onChange={(value) =>
                handleChange("serviceLineDescription", value)
              }
              pdfMode={pdfMode}
            />
          </View>
          <View className="invoice-w-17 invoice-p-4-8" pdfMode={pdfMode}>
            <EditableInput
              className="invoice-white invoice-bold invoice-right"
              value={invoice.serviceLineQuantity}
              onChange={(value) => handleChange("serviceLineQuantity", value)}
              pdfMode={pdfMode}
            />
          </View>
          <View className="invoice-w-17 invoice-p-4-8" pdfMode={pdfMode}>
            <EditableInput
              className="invoice-white invoice-bold invoice-right"
              value={invoice.serviceLineQuantityRate}
              onChange={(value) =>
                handleChange("serviceLineQuantityRate", value)
              }
              pdfMode={pdfMode}
            />
          </View>
          <View className="invoice-w-18 invoice-p-4-8" pdfMode={pdfMode}>
            <EditableInput
              className="invoice-white invoice-bold invoice-right invoice-white-width"
              value={invoice.serviceLineQuantityAmount}
              onChange={(value) =>
                handleChange("serviceLineQuantityAmount", value)
              }
              pdfMode={pdfMode}
            />
          </View>
        </View>

        {invoice.serviceLine.map((productLine, i) => {
          return pdfMode && productLine.description === "" ? (
            <Text key={i}></Text>
          ) : (
            <View
              key={i}
              className="invoice-row invoice-flex"
              pdfMode={pdfMode}
            >
              <View
                className="invoice-w-48 invoice-p-4-8 invoice-pb-10"
                pdfMode={pdfMode}
              >
                <EditableInput
                  className="invoice-dark"
                  rows={2}
                  placeholder="Enter item name/description"
                  value={productLine.description}
                  pdfMode={pdfMode}
                />
              </View>
              <View
                className="invoice-w-17 invoice-p-4-8 invoice-pb-10"
                pdfMode={pdfMode}
              >
                <EditableInput
                  className="invoice-dark invoice-right"
                  value={productLine.quantity === "" ? 0 : productLine.quantity}
                  pdfMode={pdfMode}
                />
              </View>
              <View
                className="invoice-w-17 invoice-p-4-8 invoice-pb-10"
                pdfMode={pdfMode}
              >
                <EditableInput
                  className="invoice-dark invoice-right"
                  value={productLine.rate === "" ? 0 : productLine.rate}
                  pdfMode={pdfMode}
                />
              </View>
              <View
                className="invoice-w-18 invoice-p-4-8 invoice-pb-10"
                pdfMode={pdfMode}
              >
                <Text className="invoice-dark invoice-right" pdfMode={pdfMode}>
                  {calculateAmount(productLine.quantity, productLine.rate)}
                </Text>
              </View>
            </View>
          );
        })}

        <View className="invoice-flex" pdfMode={pdfMode}>
          <View className="invoice-w-50 invoice-mt-10" pdfMode={pdfMode}></View>
          <View className="invoice-w-50 invoice-mt-20" pdfMode={pdfMode}>
            <View className="invoice-flex  " pdfMode={pdfMode}>
              <View className="invoice-w-50 " pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-bold"
                  value={invoice.serviceTotalLabel}
                  onChange={(value) => handleChange("serviceTotalLabel", value)}
                  pdfMode={pdfMode}
                />
              </View>
              <View className="invoice-w-50  invoice-flex" pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-dark invoice-bold invoice-right invoice-ml-30"
                  value={invoice.currency}
                  onChange={(value) => handleChange("currency", value)}
                  pdfMode={pdfMode}
                />
                <Text
                  className="invoice-right invoice-bold invoice-dark invoice-w-auto"
                  pdfMode={pdfMode}
                >
                  {serviceTotal?.toFixed(2)}
                </Text>
              </View>
            </View>
          </View>
        </View>

        {/* EXPENSELINE */}

        <View
          className="invoice-mt-20 invoice-bg-dark invoice-flex"
          pdfMode={pdfMode}
        >
          <View className="invoice-w-48 invoice-p-4-8" pdfMode={pdfMode}>
            <EditableInput
              className="invoice-white invoice-bold"
              value={invoice.expenseLineDescription}
              onChange={(value) =>
                handleChange("expenseLineDescription", value)
              }
              pdfMode={pdfMode}
            />
          </View>
          <View className="invoice-w-17 invoice-p-4-8" pdfMode={pdfMode}>
            <EditableInput
              className="invoice-white invoice-bold invoice-right"
              value={invoice.expenseLineQuantity}
              onChange={(value) => handleChange("expenseLineQuantity", value)}
              pdfMode={pdfMode}
            />
          </View>
          <View className="invoice-w-17 invoice-p-4-8" pdfMode={pdfMode}>
            <EditableInput
              className="invoice-white invoice-bold invoice-right"
              value={invoice.expenseLineQuantityRate}
              onChange={(value) =>
                handleChange("expenseLineQuantityRate", value)
              }
              pdfMode={pdfMode}
            />
          </View>
          <View className="invoice-w-18 invoice-p-4-8" pdfMode={pdfMode}>
            <EditableInput
              className="invoice-white invoice-bold invoice-right invoice-white-width"
              value={invoice.expenseLineQuantityAmount}
              onChange={(value) =>
                handleChange("expenseLineQuantityAmount", value)
              }
              pdfMode={pdfMode}
            />
          </View>
        </View>

        {invoice.expenseLine.map((productLine, i) => {
          return pdfMode && productLine.description === "" ? (
            <Text key={i}></Text>
          ) : (
            <View
              key={i}
              className="invoice-row invoice-flex"
              pdfMode={pdfMode}
            >
              <View
                className="invoice-w-48 invoice-p-4-8 invoice-pb-10"
                pdfMode={pdfMode}
              >
                <EditableInput
                  className="invoice-dark"
                  rows={2}
                  placeholder="Enter item name/description"
                  value={productLine.description}
                  pdfMode={pdfMode}
                />
              </View>
              <View
                className="invoice-w-17 invoice-p-4-8 invoice-pb-10"
                pdfMode={pdfMode}
              >
                <EditableInput
                  className="invoice-dark invoice-right"
                  value={productLine.quantity === "" ? 0 : productLine.quantity}
                  pdfMode={pdfMode}
                />
              </View>
              <View
                className="invoice-w-17 invoice-p-4-8 invoice-pb-10"
                pdfMode={pdfMode}
              >
                <EditableInput
                  className="invoice-dark invoice-right"
                  value={productLine.rate === "" ? 0 : productLine.rate}
                  pdfMode={pdfMode}
                />
              </View>
              <View
                className="invoice-w-18 invoice-p-4-8 invoice-pb-10"
                pdfMode={pdfMode}
              >
                <Text className="invoice-dark invoice-right" pdfMode={pdfMode}>
                  {calculateAmount(productLine.quantity, productLine.rate)}
                </Text>
              </View>
            </View>
          );
        })}
        <View className="invoice-flex" pdfMode={pdfMode}>
          <View className="invoice-w-50 invoice-mt-10" pdfMode={pdfMode}></View>
          <View className="invoice-w-50 invoice-mt-20" pdfMode={pdfMode}>
            <View className="invoice-flex  " pdfMode={pdfMode}>
              <View className="invoice-w-50 " pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-bold"
                  value={invoice.expenseTotalLabel}
                  onChange={(value) => handleChange("expenseTotalLabel", value)}
                  pdfMode={pdfMode}
                />
              </View>
              <View className="invoice-w-50  invoice-flex" pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-dark invoice-bold invoice-right invoice-ml-30"
                  value={invoice.currency}
                  onChange={(value) => handleChange("currency", value)}
                  pdfMode={pdfMode}
                />
                <Text
                  className="invoice-right invoice-bold invoice-dark invoice-w-auto"
                  pdfMode={pdfMode}
                >
                  {expenseTotal?.toFixed(2)}
                </Text>
              </View>
            </View>
          </View>
        </View>

        <View className="invoice-flex" pdfMode={pdfMode}>
          <View className="invoice-w-50 invoice-mt-10" pdfMode={pdfMode}></View>
          <View className="invoice-w-50 invoice-mt-20" pdfMode={pdfMode}>
            <View
              className="invoice-flex invoice-bg-gray invoice-p-top invoice-p-left"
              pdfMode={pdfMode}
            >
              <View className="invoice-w-50 " pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-bold"
                  value={"Professional Services"}
                  // onChange={(value) => handleChange('totalLabel', value)}
                  pdfMode={pdfMode}
                />
              </View>
              <View className="invoice-w-50  invoice-flex" pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-dark invoice-bold invoice-right invoice-ml-30"
                  value={invoice.currency}
                  onChange={(value) => handleChange("currency", value)}
                  pdfMode={pdfMode}
                />
                <Text
                  className="invoice-right invoice-bold invoice-dark invoice-w-auto"
                  pdfMode={pdfMode}
                >
                  {serviceTotal?.toFixed(2)}
                </Text>
              </View>
            </View>

            <View
              className="invoice-flex invoice-bg-gray invoice-p-left invoice-b-bottom"
              pdfMode={pdfMode}
            >
              <View className="invoice-w-50 " pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-bold"
                  value={"Expense Itemization"}
                  pdfMode={pdfMode}
                />
              </View>
              <View className="invoice-w-50 invoice-flex" pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-dark invoice-bold invoice-right invoice-ml-30"
                  value={invoice.currency}
                  onChange={(value) => handleChange("currency", value)}
                  pdfMode={pdfMode}
                />
                <Text
                  className="invoice-right invoice-bold invoice-dark invoice-w-auto"
                  pdfMode={pdfMode}
                >
                  {expenseTotal?.toFixed(2)}
                </Text>
              </View>
            </View>

            <View
              className="invoice-flex invoice-bg-gray invoice-p-left invoice-b-bottom"
              pdfMode={pdfMode}
            >
              <View className="invoice-w-50 " pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-bold"
                  value={"Retainer Credit"}
                  pdfMode={pdfMode}
                />
              </View>
              <View className="invoice-w-50 invoice-flex" pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-dark invoice-bold invoice-right invoice-ml-30"
                  value={invoice.currency}
                  onChange={(value) => handleChange("currency", value)}
                  pdfMode={pdfMode}
                />
                <Text
                  className="invoice-right invoice-bold invoice-dark invoice-w-auto"
                  pdfMode={pdfMode}
                >
                  {parseFloat(invoice?.retainerCredit).toFixed(2)}
                </Text>
              </View>
            </View>

            <View
              className="invoice-flex invoice-bg-gray invoice-p-left"
              pdfMode={pdfMode}
            >
              <View className="invoice-w-50 " pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-bold"
                  value={invoice.totalLabel}
                  onChange={(value) => handleChange("totalLabel", value)}
                  pdfMode={pdfMode}
                />
              </View>
              <View className="invoice-w-50  invoice-flex" pdfMode={pdfMode}>
                <EditableInput
                  className="invoice-dark invoice-bold invoice-right invoice-ml-30"
                  value={invoice.currency}
                  onChange={(value) => handleChange("currency", value)}
                  pdfMode={pdfMode}
                />
                <Text
                  className="invoice-right invoice-bold invoice-dark invoice-w-auto"
                  pdfMode={pdfMode}
                >
                  {subTotal?.toFixed(2)}
                </Text>
              </View>
            </View>
          </View>
        </View>

        <View className="invoice-mt-20" pdfMode={pdfMode}>
          <EditableInput
            className="invoice-bold invoice-w-100"
            value={invoice.notesLabel}
            onChange={(value) => handleChange("notesLabel", value)}
            pdfMode={pdfMode}
          />
          <EditableInput
            className="invoice-w-100"
            rows={2}
            value={invoices?.accounting_notes}
            onChange={(value) => handleChange("notes", value)}
            pdfMode={pdfMode}
          />
        </View>
        {/* <View className="invoice-mt-20" pdfMode={pdfMode}>
          <EditableInput
            className="invoice-bold invoice-w-100"
            value={invoice.termLabel}
            onChange={(value) => handleChange('termLabel', value)}
            pdfMode={pdfMode}
          />
          <EditableTextarea
            className="invoice-w-100"
            rows={2}
            value={invoice.term}
            onChange={(value) => handleChange('term', value)}
            pdfMode={pdfMode}
          />
        </View> */}
      </Page>
    </Document>
  );
}

export default InvoicePage;
